export var iconVars = {fontSize:'var(--_1ogcmc40)'};